<template>
   <div id="ancillaries-automated-c">
      <template v-if="!manuelRequestTextArea">
         <h1 class="ancillaries-automated-title">{{ $t("ancillariesAutomatedOffer_lblOpenManuelRequest") }}</h1>
      </template>
      <template v-else-if="PaymentRequired">
         <h1 class="ancillaries-automated-title">{{ $t("ancillariesAutomatedOffer_lblSelectService") }}</h1>
      </template>
      <template v-else>
         <h1 class="ancillaries-automated-title">{{ $t("ancillariesAutomatedOffer_lblSelectServiceError") }}</h1>
      </template>

      <template v-if="!PaymentRequired && !manuelRequestTextArea">
         <h2 class="ancillaries-automated-subtitle">{{ $t("ancillariesAutomatedOffer_txtInformation") }}</h2>
         <h3 class="ancillaries-automated-generic-error">{{ ancillariesAutomatedOfferGenericFMT() }}</h3>
      </template>

      <template v-if="manuelRequestTextArea">
         <ul class="ancillaries-list-wrapper">
            <template v-for="(ancillary, key) in ancillaries">
               <li
                  class="ancillary-list-item"
                  :key="key"
                  v-if="ancillary.enabled"
                  :class="(parsedData.type == 1 && ancillary.type == 9) || (parsedData.type == 2 && ancillary.type == 4) ? 'highlight' : ''"
                  @click="handlerTrigger(key)">
                  <div class="ancillary-box-wrapper">
                     <div class="ancillary-box-icon-wrapper">
                        <i class="gts-icon icon-xl" :class="ancillary.icon"></i>
                     </div>
                     <div class="ancillary-box-info-wrapper">
                        <div>
                           <span class="ancillary-title">{{ ancillary.name }} </span>
                           <p class="ancillary-description" v-if="ancillary.showDescription">
                              {{ ancillary.description }}
                           </p>
                        </div>
                     </div>
                  </div>
               </li>
            </template>
         </ul>
      </template>

      <div class="ancillaries-automated-footer-wrapper">
         <div class="ancilary-automated-footer-seperator" v-if="manuelRequestTextArea && !AllAncillariesDisabled">
            <span class="seperator-line"></span>
            <span class="or-txt">{{ $t("ancillariesAutomatedOffer_lblOR") }}</span>
            <!-- <span>*</span> -->
         </div>

         <template v-if="manuelRequestTextArea">
            <UIButton className="hotel" :text="$t('ancillariesAutomatedOffer_lblOpenManuelRequest')" @click.native="manuelRequestTextArea = false" />
         </template>
         <template v-else>
            <div class="textarea-wrapper">
               <textarea name="" id="addNewNote" rows="5" v-model="serviceCenterNote" :placeholder="$t('requestFormComponent_textareaPlaceholder_label')"></textarea>
               <div class="textarea-cta-wrapper">
                  <UIButton className="hotel_outline" :text="$t('serviceCenterRequestForm_btnCancel')" @click.native="manuelRequestTextArea = true" />
                  <UIButton className="hotel" :text="$t('serviceCenterRequestForm_btnSend')" @click.native="handlerCreateTask" :isSpinnerActive="taskCreating" />
               </div>
            </div>
         </template>
         <template v-if="PaymentRequired">
            <h2 class="ancillaries-automated-subtitle">{{ $t("ancillariesAutomatedOffer_lblSelectServiceSubTitlePaymentRequired") }}</h2>
         </template>
         <!--<p>
             {{ $t("ancillariesAutomatedOffer_txtInformation") }} 
         </p>-->
      </div>
      <!-- <UIButton className="default" :text="$t('common_add')" /> -->
   </div>
</template>

<script>
import UIButton from "@/components/unitary/Button.vue";
import { generateUuid } from "@/utils.js";
import { tasklistService } from "@/service/index.js";
import Popup from "@/gts-popup.js";
import { ancillariesListFunction } from "@/helper/ancillariesList.js";
export default {
   name: "AncillariesAutomated",
   props: {
      choices: Object,
   },
   components: {
      UIButton,
   },
   data() {
      return {
         ancillaries: ancillariesListFunction(this.choices),
         manuelRequestTextArea: true,
         serviceCenterNote: "",
         parsedData: {},
         offerKey: "",
         taskCreating: false,
      };
   },
   mounted() {
      this.$nextTick(() => {
         const jsonData = document.getElementById("scrf-debug").dataset.json;
         const parsedData = JSON.parse(jsonData);
         this.parsedData = parsedData;
         this.serviceCenterNote = parsedData.description;
         this.$store.commit("app/setIsProgressGifActive", false);
         const refundStatus = this.$store.state.flight.ancillaryErrors.showReverseInquiry;
         this.ancillaries.refund.enabled = refundStatus;
      });
   },
   computed: {
      AllAncillariesDisabled() {
         return Object.values(this.ancillaries).every((item) => item.enabled === false);
      },
      PaymentRequired() {
         return this.$store.state.app.modalViewStatus.paymentRequired;
      },
      ShowReverseInquiry() {
         return this.$store.state.flight.ancillaryErrors.showReverseInquiry;
      },
   },

   methods: {
      ancillariesAutomatedOfferGenericFMT() {
         return this.$t(this.$store.state.flight.ancillaryErrors.errorMsg);
      },
      handlerCreateTask() {
         this.taskCreating = true;
         this.parsedData.description = this.serviceCenterNote;
         const self = this;
         let type = this.$store.state.flight.ancillaryErrors.type ?? this.parsedData.type;
         let query = {
            type: type,
            orderId: this.parsedData.orderId,
            description: this.parsedData.description,
            entityId: this.parsedData.entityId,
            uuid: generateUuid(),
            errorId: this.$store.state.app.modalViewStatus.errorId,
         };

         tasklistService.addTask(query).then((response) => {
            if (response.result.success) {
               self.redirectTask = response.taskId;
               Popup.success(this.$i18n.t("popup_successTitle"), this.$i18n.t("serviceCenterRequestForm_popupTaskCreate"), undefined, 10000, true).confirmed((res) => {
                  if (res.success) {
                     this.$router.push(self.$route.path + "?taskopen=true");
                     window.location.reload();
                  }
               });
            }
            this.$store.commit("app/setModalViewStatus", { status: false, paymentRequired: false });
            this.taskCreating = false;
         });

         tasklistService;
         query;
      },
      handlerTrigger(key) {
         this.offerKey = key;
         this.$store.commit("app/setModalViewStatus", { status: false, paymentRequired: false });
         if (key != "onlineCheckin") {
            this.$store.commit("app/setModalViewStatus", { status: true, paymentRequired: false });
         }

         this.$store.state.app.progress.message = this.$i18n.t("flightOrderDetail_lblAutomatedSSRs");
         this.$emit("handlerTrigger", key);
      },
   },
};
</script>

<style lang="scss" scoped>
#ancillaries-automated-c {
   .ancillaries-automated-title {
      width: 100%;
      text-align: center;
      font-weight: 600;
      font-size: var(--large);
      margin-bottom: 0.5rem;
   }
   .ancillaries-automated-subtitle {
      width: 100%;
      text-align: center;
      font-weight: 400;
      font-size: var(--large);
      margin: 0;
      // color: red;
   }
   .ancillaries-automated-generic-error {
      width: 100%;
      text-align: center;
      font-weight: 500;
      font-size: var(--normal);
      margin: 0;
      color: #d4aa00;
      margin-bottom: 1rem;
      background-color: #fdfae8;
      padding: 0.5rem;
   }
   ul.ancillaries-list-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      gap: 0.75rem;

      li.ancillary-list-item {
         border: 2px solid #f2f4f7;
         border-radius: 1rem;
         background-color: #f9fafb;
         padding: 1.5rem;
         display: flex;
         justify-content: center;
         min-width: 180px;
         transition: all 0.125s ease-out;
         @media (max-width: 576px) {
            min-width: auto;
            padding: 0.5rem;
         }
         @media (max-width: 768px) {
            // width: 90%;
         }
         @media (max-width: 1200px) {
            // width: 90%;
         }

         &.highlight {
            border: 4px solid #cfd0d1;
         }
         &.is-disabled {
            opacity: 0.5;
         }

         .ancillary-box-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
         }

         &:hover {
            cursor: pointer;
            border: 2px solid #ccc;
            transform: scale(1.05);
         }
      }
   }

   .ancillaries-automated-footer-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 2rem;
      .ancilary-automated-footer-seperator {
         font-size: var(--xlarge);
         font-weight: 600;

         position: relative;
         padding: 0 2rem;

         .seperator-line {
            position: absolute;
            display: block;
            width: 100%;
            height: 2px;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background: black;
            margin: auto 0;
         }
         .or-txt {
            position: relative;
            color: black;
            background-color: #fff;
            padding: 0 0.5rem;
         }

         &::before,
         &::after {
            width: 8px;
            height: 8px;
            background: black;
            display: block;
            border-radius: 50%;
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto 0;
         }
         &::before {
            content: "";
            left: 0;
         }
         &::after {
            content: "";
            right: 0;
         }

         span {
            // &:first-child {
            //    background: red;
            // }
            // &:last-child {
            //    background: blue;
            // }
         }
      }
      button {
         // background-color: orange;
         border-radius: 0.5rem;
         // padding: 0.5rem 2rem;
         // color: #fff;
         // font-size: var(--normal);
         // font-weight: 600;
         // width: fit-content;
         margin: 1.5rem 0;
      }
      p {
         text-align: center;
         width: 65%;
         font-size: var(--small);
         opacity: 0.65;
      }

      .textarea-wrapper {
         width: 80%;
         textarea {
            width: 100%;
            padding: 1rem;
            border-radius: 1rem;
         }
         .textarea-cta-wrapper {
            display: flex;
            justify-content: flex-end;

            button {
               margin-right: 1rem;
            }
         }
      }
   }
}
</style>
